import React, {useRef, useState} from "react";
import {Button, Grid, TextField, Typography} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import FormRadio from "../components/core/FormRadio";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SelectComponent from "../components/core/SelectComponent";
import {onBoardHospitals} from "../utils/API";
import Header from "../components/core/Header";
import {ArrowForward} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    LeftContainer: {
        //margin:theme.spacing(3),
        display: "flex",
        flexDirection: "column !important",
        flexWrap: "warp",
        alignItems: "center",
        padding: theme.spacing(2),
        background: "#4D88FE",
        minHeight: "100vh",
        minWidth: "50vh",
    },
    paper: {
        margin: theme.spacing(8),
        // marginBottom: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(3),
    },
    avatar: {
        padding: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        width: "12rem",
        borderRadius: "3px",
        marginBottom: theme.spacing(2),
    },
    form: {
        width: "100%",
        marginTop: theme.spacing(1),
        color: "#fff",
    },
    submit: {
        marginTop: theme.spacing(2),
    },
    branding: {
        //fontFamily: 'AvantGardeRegular',
        color: "#000",
    },
}));

function OnBoardHosp() {
    const classes = useStyles();
    const zoneList = JSON.parse(localStorage.getItem("copayZones"));
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const hospitalName = useRef();
    const hosCode = useRef();
    const [zone, setZone] = useState();
    const [active, setActive] = useState({value: false, label: "False"});
    const [deleted, setDeleted] = useState({value: false, label: "False"});
    const [vneuronEnabled, setVneuronEnabled] = useState({
        value: true,
        label: "True",
    });
    const [pmlEnabled, setPMLEnabled] = useState({value: true, label: "True"});
    const [tariffEnabled, setTariffEnabled] = useState({
        value: true,
        label: "True",
    });

    const onBoardHospital = async (event) => {
        event.preventDefault();
        const data = {
            name: hospitalName.current?.value,
            hospitalCode: hosCode.current?.value,
            type: "HOSPITAL",
            corporateIdList: null,
            insuranceAgencyId: parseInt(localStorage.getItem("insurerId")),
            zone: zone,
            active: active.value,
            deleted: deleted.value,
            vneuronEnabled: vneuronEnabled.value,
            pmlEnabled: pmlEnabled.value,
            tariffEnabled: tariffEnabled.value,
            procedures: "all",
        };
        await onBoardHospitals(data);
    };

    return (
        <Grid container>
            <Header/>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    border: "1px solid",
                    padding: 10,
                    height: "1.5rem",
                    marginLeft: 30,
                    marginTop: 30,
                    background: "#000",
                    cursor: "pointer",
                }}
            >
                <div style={{color: "#fff"}}>
                    <ArrowBackIcon/>
                </div>

                <Link to={"/"} style={{textDecoration: "none", color: "#fff"}}>
                    {" "}
                    Go Back
                </Link>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    border: "1px solid",
                    padding: 10,
                    height: "1.5rem",
                    marginLeft: 30,
                    marginTop: 30,
                    background: "#000",
                    cursor: "pointer",
                }}
            >
                <Link to={"/onboarding-rooms"} style={{textDecoration: "none", color: "#fff"}}>
                    {" "}
                    Go To Onboard Rooms
                </Link>
                <div style={{color: "#fff"}}>
                    <ArrowForward/>
                </div>
            </div>
            <Grid
                item
                xl
                lg
                md
                xs={2}
                style={{
                    minHeight: "100vh",
                    minWidth: "50vh",
                    paddingTop: "1vh",
                    width: "100%",
                }}
            >
                <div className={classes.paper}>
                    {/*<img className={classes.avatar} src={Logo} alt=""/>*/}
                    <Typography component="h1" variant="h5" className={classes.branding}>
                        Onboard hospitals for Insurer dashboard
                    </Typography>
                    <div style={{margin: 30, padding: "0 10%"}}>
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="hospitalName"
                                label="Hospital Name"
                                name="hospitalName"
                                autoComplete="name"
                                autoFocus
                                inputRef={hospitalName}
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="hospitalCode"
                                label="Hospital Code"
                                type="text"
                                id="hospitalCode"
                                autoComplete="code"
                                inputRef={hosCode}
                            />
                            {/* <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="zone"
                label="Zone"
                type="text"
                id="zone"
                autoComplete="zone"
                inputRef={zone}
              /> */}
                            <SelectComponent
                                label="Select Zone"
                                menuItem={zoneList}
                                setSelections={setZone}
                                required={true}
                            />
                            <Grid
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "20px",
                                    marginTop: "20px",
                                }}
                            >
                                <FormRadio
                                    value={active}
                                    setValue={setActive}
                                    label={"Choose active"}
                                    options={[
                                        {value: true, label: "True"},
                                        {value: false, label: "False"},
                                    ]}
                                />
                                <FormRadio
                                    value={deleted}
                                    setValue={setDeleted}
                                    label={"Choose deletion"}
                                    options={[
                                        {value: true, label: "True"},
                                        {value: false, label: "False"},
                                    ]}
                                />
                                <FormRadio
                                    value={vneuronEnabled}
                                    setValue={setVneuronEnabled}
                                    label={"Choose vNeuron to enabled"}
                                    options={[
                                        {value: true, label: "True"},
                                        {value: false, label: "False"},
                                    ]}
                                />
                                <FormRadio
                                    value={pmlEnabled}
                                    setValue={setPMLEnabled}
                                    label={"Choose pml to enabled"}
                                    options={[
                                        {value: true, label: "True"},
                                        {value: false, label: "False"},
                                    ]}
                                />
                                <FormRadio
                                    value={tariffEnabled}
                                    setValue={setTariffEnabled}
                                    label={"Choose tariff to enabled"}
                                    options={[
                                        {value: true, label: "True"},
                                        {value: false, label: "False"},
                                    ]}
                                />
                            </Grid>

                            <Typography variant="body1" color="error">
                                {error}
                            </Typography>

                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                onClick={(event) => onBoardHospital(event)}
                                style={{marginTop: "20px"}}
                            >
                                {"Submit"}
                            </Button>
                        </form>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
}

export default OnBoardHosp;
